import { render, staticRenderFns } from "./DocumentSelector.vue?vue&type=template&id=350b03fa&scoped=true"
import script from "./DocumentSelector.vue?vue&type=script&lang=js"
export * from "./DocumentSelector.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelector.vue?vue&type=style&index=0&id=350b03fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350b03fa",
  null
  
)

export default component.exports